import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {Button} from "antd";
import {MANAGER_PATH} from "@/constant/url-path.ts";

export const DetailButton = ({record}: { record: LicenseRegistrationItemSearch }) => {
    const {t} = useTranslation();
    const navigation = useNavigate();

    return (
        <Button
            color={'primary'}
            variant={'filled'}
            onClick={() => {
                const params = new URLSearchParams();
                params.append("id", String(record?.licenseRegistrationId));
                navigation(`${MANAGER_PATH.LICENSE_REGISTRATION.DETAIL}?${params.toString()}`)
            }}
        >
            {t('button.detail')}
        </Button>
    )
}